import React from "react";
import { PaRequirementsList } from "../components/PaRequirementsList";

export const GroupIdSpecificPaRequirementsTab = () => {
  return <PaRequirementsList groupSpecific={true} />;
};
